import React from "react";
import { Row, Col } from "react-bootstrap";
import CustomTooltip from "utils/CustomTooltip";
import InflationForm from "./InflationForm";

export default function Social(props) {
  let platformNames = ["Facebook"];

  return (
    <div style={{ backgroundColor: "#F5F5F5" }}>
      <Row className="p-4">
        <Col>
          <div className="py-4">
            <p>Social does not have inflation so there is no need to do this for social</p>
            {/* <span className="text-info visby-bold f-18">
              InflationForm (Past 30 Days)
            </span>
            <span>
              <CustomTooltip
                faClass="far text-info fa-question-circle pl-2"
                message="Test"
                inline={true}
              />
            </span>
            <div className="py-4">
            <InflationForm inflation={props.inflation} setInflation={props.setInflation} platforms={platformNames} section={"social"} />
            </div> */}
          </div>
        </Col>
      </Row>
    </div>
  );
}
